import { Link } from 'react-router-dom';
import logo from '../../../assets/images/resources/SCLOGO1.png';
import MenuItems from './MenuItems'; // added

const mobileMenuStyles = `
.mobile-nav__content .main-menu__list a {
  color: #fff !important;
}
.mobile-nav__content .main-menu__list li {
  color: #fff !important;
}
`;

const MobileMenu = ({ handleMobileMenu }) => {
  return (
    <>
      <style>{mobileMenuStyles}</style>
      <div className="w-full mobile-nav__wrapper">
        <div className="w-full mobile-nav__overlay mobile-nav__toggler" onClick={handleMobileMenu}></div>
        <div className="mobile-nav__content">
          <span className="w-full mobile-nav__close mobile-nav__toggler" onClick={handleMobileMenu}>
            <i className="fa fa-times"></i>
          </span>
          <div className="logo-box">
            <Link to="/" aria-label="logo image">
              <img src={logo} width="100" alt="Logo" />
            </Link>
          </div>
          <div className="mobile-nav__container">
            <div className="clearfix collapse navbar-collapse show" style={{ display: 'block' }}>
              <ul className="main-menu__list" style={{ display: 'block', listStyle: 'none', padding: '0', margin: '0' }}>
                <MenuItems handleMobileMenu={handleMobileMenu} />
              </ul>
            </div>
          </div>
          <ul className="mobile-nav__contact list-unstyled">
            <li>
              <i className="fa fa-phone-alt"></i>
              <a href="tel:9983333188">9983333188</a>
            </li>
          </ul>
          <div className="mobile-nav__top">
            <div className="mobile-nav__social">
              <a href="https://x.com/sunrisingcinevisionacademy.in/" target="_blank" rel="noopener noreferrer" className="fab fa-twitter"></a>
              <a href="https://facebook.com/sunrisingcinevisionacademy.in/" target="_blank" rel="noopener noreferrer" className="fab fa-facebook-square"></a>
              <a href="https://instagram.com/sunrisingcinevisionacademy.in/" target="_blank" rel="noopener noreferrer" className="fab fa-instagram"></a>
              <a href="mailto:info@sunrisingcinevisionacademy.in" className="fa fa-envelope"></a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MobileMenu;
